import { Navigate, Route, Routes } from 'react-router-dom';
import CouponsPage from '../pages/coupons-page';
import CouponFormPage from '../pages/coupon-form-page';

export const CouponsRoutes = () => {
  return (
    <Routes>
      <Route index element={<CouponsPage />} />
      <Route path="new" element={<CouponFormPage />} />
      <Route path="edit/:coupon_id" element={<CouponFormPage />} />
      <Route path=":id" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default CouponsRoutes;
